<template>
  <search-bar :search="search" class-btn-search="btn btn-primary icon-magnifier form-group right" ref="search">
    <div class="row">
      <div class="col-md-12">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" style="width: 65px;">Projeto</span>
          </div>
          <input type="text"
                 class="form-control"
                 id="basic-url"
                 aria-describedby="basic-addon3"
                 v-on:keyup.enter="filtrar"
                 placeholder="Nome do Projeto"
                 v-model="search.name"
                 style="width: calc(100% - 65px)">
        </div>
      </div>
    </div>
  </search-bar>
</template>

<script>
  import { SearchBar } from 'metawesome-datatable';
  import Uteis from '@/mixins/utils.js';


  export default {
    components: {
      SearchBar,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        search: {
          name: '',
        },
      };
    },

    mounted() {
      this.$refs.search.$on('filter-set', (filter) => {
        this.$emit('filter-set', filter);
      });

      this.filtrar();
    },

    methods: {
      filtrar() {
        this.$emit('filter-set', this.search);
      },
    }
  };
</script>
